import LiveFeedback from '../../Page/Manage/LiveList/Component/LiveFeedback';
import { ReactNode } from 'react';
import styled from 'styled-components';
import LiveDetailDialog from '../../Page/Manage/LiveList/Component/LiveDetailDialog';
import CancellationReasonField from './CancellationReasonField';

export default function AdminCancellationDialog({ open, title, description, reason, onReasonChange, busy = false, error,
  onClose, onConfirm, children, canConfirm = true, confirmLabel = '취소하기', refundLayout = false }: { open: boolean; title: string; description?: ReactNode; reason: string; children?: ReactNode; canConfirm?: boolean; confirmLabel?: string; refundLayout?: boolean;
  onReasonChange: (value: string) => void; busy?: boolean; error?: string; onClose: () => void; onConfirm: () => void;
}) {
  return <LiveDetailDialog open={open} title={title} size={refundLayout ? "medium" : "compact"} onClose={() => { if (!busy) onClose(); }}
    footer={<Actions><button type="button" disabled={busy} onClick={onClose}>닫기</button>
      <button type="button" className="primary" disabled={busy || !canConfirm || !reason.trim()} onClick={onConfirm}>
        {busy ? '처리 중…' : confirmLabel}</button></Actions>}>
    <Content $refund={refundLayout}>
    {description && <Summary>{description}</Summary>}
    {children}
    <CancellationReasonField value={reason} onChange={onReasonChange} disabled={busy} />
    {error && <Error as={LiveFeedback} role="alert">{error}</Error>}
    </Content>
  </LiveDetailDialog>;
}
const Summary = styled.div`margin-bottom: var(--space-4); color: var(--color-text-secondary); font-size: var(--text-body); line-height: var(--leading-body);`;
const Error = styled.p`color: var(--color-text-danger); font-size: var(--text-body);`;
const Actions = styled.div`
  display: flex; justify-content: flex-end; gap: var(--space-2);
  button { min-height: var(--control-sm); padding: 0 var(--space-3); border: 1px solid var(--color-border-default);
    border-radius: var(--radius-md); background: var(--color-bg-surface); color: var(--color-text-primary); font: inherit; cursor: pointer; }
  .primary { border-color: transparent; background: var(--gradient-brand); color: var(--color-text-on-brand); }
  button:disabled { background: var(--color-bg-muted); border-color: var(--color-border-default); color: var(--color-text-disabled); cursor: default; }
  button:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: 2px; }
  @media (pointer: coarse) { button { min-height: var(--touch-target); } }
`;

const Content = styled.div<{ $refund: boolean }>`
  min-width: 0;
  ${props => props.$refund && `font-variant-numeric: tabular-nums; > :last-child { margin-bottom: 0; }`}
`;
